/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPicklistOption
 */
export interface PccPicklistOption {
    /**
     * 
     * @type {string}
     * @memberof PccPicklistOption
     */
    value: string;
}

/**
 * Check if a given object implements the PccPicklistOption interface.
 */
export function instanceOfPccPicklistOption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function PccPicklistOptionFromJSON(json: any): PccPicklistOption {
    return PccPicklistOptionFromJSONTyped(json, false);
}

export function PccPicklistOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPicklistOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function PccPicklistOptionToJSON(value?: PccPicklistOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

